<template>
    <div class="modal fade" id="modal_add_bilan" tabindex="-1" data-bs-backdrop="static">

        <div class="modal-dialog modal-lg">
            <div class="modal-content position-relative">

                <loader-gif v-if="isRequestBilan" />

                <div class="modal-header">
                    <h5 class="modal-title">
                        {{ action === 'add'
                            ? i18n.t('views.clients.bilans.add')
                            : i18n.t('views.clients.bilans.edit') }}
                    </h5>

                    <button type="button" class="btn-close" @click="closeModal('modal_add_bilan', 'add')" />
                </div>

                <div class="modal-body">
 
                    <!-- information income (rocette) -->
                    <informations-income />
                    <!-- end information income (rocette) -->
                     
                    <div v-if="income && income?.remaining_sessions === 0" class="row">
                        <div class="col-md-12">
                            <div class="message message-expired">
                                <p><b>Bilan impossible</b></p>
                                <p>Toutes les séances de bilan ont été utilisées. Veuillez renouveler pour pouvoir
                                    effectuer un nouveau bilan</p>
                            </div>
                        </div>
                    </div>

                    <form v-else @submit.prevent="submitForm" class="forms-sample">

                        <div class="row">
                            <hr>
                            <div class="row mb-3">

                                <div class="col-md-6  mb-2">
                                    <radioInput v-model="isCaputre" :valueAttr="1"
                                        :label="i18n.t('button.upload_image')" :name="`isCaputre`" id="club-logo-1" />
                                </div>
                                <div class="col-md-6  mb-2">
                                    <radioInput v-model="isCaputre" :valueAttr="0" :label="i18n.t('button.take_photo')"
                                        :name="`isCaputre`" id="club-logo-0" />
                                </div>
                            </div>
                            <div class="row  mb-4">
                                <div v-if="isCaputre" class="col-md-12 mb-3">
                                    <div class="form-group mr-b-0em">
                                        <input-image v-model="requestBilan.path_image"
                                            :label="i18n.t('tables.club.path_image')" :pathImage="image"
                                            :v="v$.path_image" :disabled="false" />
                                    </div>
                                </div>
                                <div v-if="!isCaputre" class="col-md-12">
                                    <capture-photo v-model="requestBilan.path_image" :v="v$.path_image"
                                        :pathImage="image" />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <SingleSelect :TextLabel="i18n.t('tables.session.trainer')" :trackby="`id`"
                                    :label="`name`" :valueProp="`id`" v-model="requestBilan.trainer_id"
                                    :placeholder="i18n.t('tables.session.trainer')" :arrayOptions="trainersList"
                                    refs="trainers" :v="v$.trainer_id" />
                            </div>
                            <div class="col-md-6">
                                <date-field v-model="requestBilan.bilan_date"
                                    :label="i18n.t('tables.bilans.bilan_date')" :v="v$.bilan_date" :disabled="false"
                                    :fixedDays="0" :isFixedDays="false" />
                            </div>
                            <div class="col-md-12">
                                <inputTextarea v-model="requestBilan.notes" :label="i18n.t('tables.bilans.notes')"
                                    :v="v$.notes" />
                            </div>

                            <div class="col-md-6">
                                <inputText v-model="requestBilan.measurements.weight"
                                    :label="i18n.t('tables.bilans.measurements.weight')" :disabled="false" />
                            </div>

                            <div class="col-md-6">
                                <inputText v-model="requestBilan.measurements.height"
                                    :label="i18n.t('tables.bilans.measurements.height')" :disabled="false" />
                            </div>

                            <div class="col-md-6">
                                <inputText v-model="requestBilan.measurements.fat_percentage"
                                    :label="i18n.t('tables.bilans.measurements.fat_percentage')" :disabled="false" />
                            </div>

                            <div class="col-md-6">
                                <inputText v-model="requestBilan.measurements.muscle_mass"
                                    :label="i18n.t('tables.bilans.measurements.muscle_mass')" :disabled="false" />
                            </div>

                            <div class="col-md-6">
                                <inputText v-model="requestBilan.measurements.chest"
                                    :label="i18n.t('tables.bilans.measurements.chest')" :disabled="false" />
                            </div>

                            <div class="col-md-6">
                                <inputText v-model="requestBilan.measurements.waist"
                                    :label="i18n.t('tables.bilans.measurements.waist')" :disabled="false" />
                            </div>

                            <div class="col-md-6">
                                <inputText v-model="requestBilan.measurements.arms"
                                    :label="i18n.t('tables.bilans.measurements.arms')" :disabled="false" />
                            </div>

                        </div>

                        <div class="row">
                            <div class="col-12 text-right mt-3">

                                <button type="submit" class="btn btn-primary mr-2">
                                    {{ action === 'add'
                                        ? i18n.t('button.add')
                                        : i18n.t('button.edit') }}
                                </button>

                                <button type="button" class="btn btn-cancel" @click="emptyState">
                                    {{ i18n.t('button.clean') }}
                                </button>

                            </div>

                        </div>

                    </form>

                </div>

            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, toRefs, watch, computed, defineEmits } from "vue";

import inputText from "@/components/inputsValidation/ReusableInput.vue";
import SingleSelect from "@/components/inputsValidation/SingleSelect.vue";
import inputTextarea from "@/components/inputsValidation/ReusableTextarea.vue";
import radioInput from "@/components/inputsValidation/radioInput.vue";

import { useVuelidate } from "@vuelidate/core";
import { required, helpers } from "@vuelidate/validators";

import i18n from "@/i18n/index";

import { useModal } from "@/composables/modal/useModal";
import { useBilan } from "@/composables/bilan/useBilan";
import { useGlobal } from "@/composables/global/useGlobal";


import { clubUUID, trainers, singleIncome } from "@/shared/state";
import { BilanRequest } from "@/interfaces/bilan";

import { useImageConverter } from '@/composables/global/useImageConverter';

export default defineComponent({
    components: { inputText, SingleSelect, inputTextarea, radioInput },
    emits: ['saved'],
    props: {
        bilan: { type: Object, default: null },
        memberUUID: { type: String, default: null },

    },

    setup(props, { emit }) {

        const { bilan, memberUUID } = toRefs(props);
        const isCaputre = ref<any>(0)

        const action = ref<'add' | 'edit'>('add');

        const image = ref<any>(null)
        const { closeModal } = useModal();
        const { formatDate } = useGlobal();
        const { addBilan, editBilan, isRequestBilan, errorBilan } = useBilan();

        const trainersList = computed(() => trainers.data);
        const income = computed(() => singleIncome.data);
        const { selectedImage } = useImageConverter();
     


        



        const defaultMeasurements = () => ({
            weight: null,
            height: null,
            fat_percentage: null,
            muscle_mass: null,
            chest: null,
            waist: null,
            arms: null
        });

        const requestBilan = ref<BilanRequest>({
            id: null,
            income_id: income?.value?.id ?? null,
            memberUUID: income?.value?.member_info?.uuid ?? null,
            trainer_id: null,
            measurements: defaultMeasurements(),
            notes: null,
            bilan_date: null,
            path_image: null,
        });

        const rules = {
            //memberUUID: { required: helpers.withMessage(i18n.t("validation.required"), required) },
            // trainer_id: { required: helpers.withMessage(i18n.t("validation.required"), required) },
            bilan_date: { required: helpers.withMessage(i18n.t("validation.required"), required) },
            notes: { required: helpers.withMessage(i18n.t("validation.required"), required) },
        };

        const v$ = useVuelidate(rules, requestBilan, { $scope: 'bilans' });

        const submitForm = async () => {
            requestBilan.value.income_id = income?.value?.id ?? null
            requestBilan.value.memberUUID = income?.value?.member_info?.uuid ?? null
            v$.value.$touch();
            console.log(requestBilan.value)
            if (!v$.value.$invalid) {

                if (action.value === 'add') {
                    await addBilan(requestBilan.value)

                    if (!errorBilan.value)
                        emptyState();

                } else {
                    await editBilan(requestBilan.value);

                    if (!errorBilan.value)
                        closeModal('modal_add_bilan', 'add');
                }
                emit('saved');
            }
        };

        const emptyState = () => {

            action.value = 'add';

            requestBilan.value = {
                id: null,
                income_id: income?.value?.id ?? null,
                memberUUID: income?.value?.member_info?.uuid ?? null,
                trainer_id: null,
                measurements: defaultMeasurements(),
                notes: null,
                bilan_date: null,
            };
            selectedImage.value = null
            image.value = null
            v$.value.$reset();

            closeModal('modal_add_bilan', 'add');
        };

        const initState = (item: any) => {
            console.log(item?.id)
            if (item?.id) {

                action.value = 'edit';
                requestBilan.value = {
                    id: item.id,
                    income_id: item.income_id,
                    memberUUID: item?.member?.uuid ?? null,
                    trainer_id: item.trainer_id,
                    measurements: typeof item.measurements === 'string'
                        ? JSON.parse(item.measurements)
                        : (item.measurements || defaultMeasurements()),
                    notes: item.notes,
                    bilan_date: item.bilan_date,
                    path_image: null,
                };
                image.value = item?.path_image ? item?.path_image : null

                v$.value.$reset();

            } else {
                action.value = 'add';
                requestBilan.value = {
                    id: null,
                    income_id: income?.value?.id ?? null,
                    memberUUID: income?.value?.member_info?.uuid ?? null,
                    trainer_id: null,
                    measurements: defaultMeasurements(),
                    notes: null,
                    bilan_date: null,
                };
                image.value = null
                //v$.value.$reset();
            }
        };

        watch(
            () => selectedImage.value,
            (newValue) => {
                requestBilan.value.path_image = selectedImage.value
                image.value = selectedImage.value ?? null
            });

        watch(
            () => bilan.value,
            (val) => initState(val),
            { immediate: true }
        );

        return {
            income,
            isCaputre,
            image,
            trainersList,
            i18n,
            action,
            requestBilan,
            submitForm,
            emptyState,
            isRequestBilan,
            closeModal,
            formatDate,
            v$
        };
    }
});
</script>